export default __webpack_public_path__ + "static/media/junkrat.78efd11a.webp";